import React, { Component } from "react";
import {
  Container,
  Col,
  Form,
  FormGroup,
  Spinner,
  Button,
} from "react-bootstrap";
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  FormControlLabel,
  RadioGroup,
  Radio,
} from "@material-ui/core";

import { v4 as uuidv4 } from "uuid";
import {
  GetClusters,
  GetAreas,
  GetBranchByCode,
} from "../../../../store/actions/crdm_service_actions";
import AsyncSelect from "react-select/async";

import {
  GetAverageByArea_v4,
  GetAverageByCluster_v4,
  GetOverallAverage_v4,
  GetAverageByBranch_v4,
} from "../../../../store/actions/reports-v4/sales_service_actions";

import { connect } from "react-redux";
import { DatePicker } from "@material-ui/pickers";
import moment from "moment";
import { closeModal } from "../../../../store/actions/ModalActions";
import { renderChartTitle } from "../../../../helpers/chartTitleBuilder";
import {
  moduleNames,
  OperationScope,
} from "../../../../helpers/dashboardModuleNames";
import { SetChartSalesAverageTitle } from "../../../../store/actions/reports/chart_title_actions";
import { toastr } from "react-redux-toastr";

import { leapYear } from "../../../../helpers/datehelpers";

const createData = (uuid, current, previous) => {
  return { uuid, current, previous };
};

class AverageViewFilter extends Component {
  state = {
    clusters: [],
    areas: [],
    branches: [],

    isBusy: false,

    toView: "overall",
    previewText: "All Clusters",
    isClusterLoading: false,
    isAreaLoading: false,

    clusterSelectContext: null,
    areaSelectContext: null,
    date: new Date(),
    clusterId: null,
    areaId: null,
  };

  componentDidMount() {
    this.openLoading();

    this.props.GetClusters().then((resp) => {
      if (resp.problem === null) {
        this.setState({ isClusterLoading: false, clusters: resp.data });
      }
    });

    this.props.GetAreas().then((resp) => {
      if (resp.problem === null) {
        this.setState({ isAreaLoading: false, areas: resp.data });
      }
    });

    this.closeLoading();
  }

  openLoading = () => {
    this.setState({ isClusterLoading: true, isAreaLoading: true });
  };
  closeLoading = () => {
    this.setState({ isClusterLoading: false, isAreaLoading: false });
  };

  handleCluster = (d) => {
    this.setState({
      clusterId: d.target.value.id,
      clusterSelectContext: d.target.value,
    });
  };

  handleArea = (d) => {
    this.setState({
      areaId: d.target.value.areaCode,
      areaSelectContext: d.target.value,
    });
  };

  handleRadioChanged = (e) => {
    this.setState({
      toView: e.target.value,
      clusterId: null,
      areaId: null,
      areaSelectContext: null,
      clusterSelectContext: null,
    });

    switch (e.target.value) {
      case "clusters":
        this.setState({ previewText: "All Clusters" });
        break;

      case "areas":
        this.setState({ previewText: "All Areas" });

        break;
      default:
        this.setState({ previewText: "No Values" });
        break;
    }
  };

  renderClusters = () => {
    return (
      <FormControl variant="outlined" fullWidth>
        <InputLabel id="demo-simple-select-outlined-label">Cluster</InputLabel>
        <Select
          id="demo-simple-select-outlined"
          disabled={!this.state.toView === "clusters"}
          value={this.state.clusterSelectContext}
          onChange={this.handleCluster}
        >
          {this.state.clusters.map((data, key) => {
            return (
              <MenuItem value={data} key={key}>
                <span>{data.name} </span>
                <span className="text-danger ml-2 bold">{data.code}</span>
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    );
  };

  renderAreas = () => {
    return (
      <FormControl variant="outlined" fullWidth>
        <InputLabel id="demo-simple-select-outlined-label">Area</InputLabel>
        <Select
          id="demo-simple-select-outlined"
          disabled={!this.state.toView === "clusters"}
          value={this.state.areaSelectContext}
          onChange={this.handleArea}
        >
          {this.state.areas.map((data, key) => {
            return (
              <MenuItem value={data} key={key}>
                {`${data.areaName}`}
                <span className="text-danger">({data.areaCode})</span>
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    );
  };

  createFilterDate = () => {
    let { dates } = this.state;
    dates.push(createData(uuidv4(), Date.now(), Date.now()));
    this.setState({ dates });
  };

  removeFilterDate = (data) => {
    let { dates } = this.state;
    const index = dates.indexOf(data);
    dates.splice(index, 1);
    this.setState({ dates });
  };

  handleCurrentDate = (fieldData) => {
    this.setState({ date: fieldData });
  };

  renderView = () => {
    return (
      <Form>
        <Form.Row>
          <Col>{this.renderScopeView()}</Col>
        </Form.Row>
        <Form.Row>
          <Col hidden={this.state.toView !== "clusters"}>
            {this.renderClusters()}
          </Col>
          <Col hidden={this.state.toView !== "areas"}>{this.renderAreas()}</Col>
        </Form.Row>
        <Form.Row>
          <Col>{this.RenderDates()}</Col>
        </Form.Row>
      </Form>
    );
  };

  PremiseGetBranchByCode = (code) => {
    return this.props.GetBranchByCode(code);
  };
  loadOptions = (inputValue, callback) => {
    // do some work

    if (inputValue.length >= 3) {
      this.PremiseGetBranchByCode(inputValue).then((resp) => {
        if (resp.problem === null) {
          if (resp.data && resp.data.length > 0) {
            const currentItem = resp.data[0];
            return callback([
              {
                label: `(${currentItem.branchCode}) ${currentItem.branchName}`,
                value: currentItem.branchCode,
              },
            ]);
          }

          return callback([]);
        }

        return callback([]);
      });
    } else {
      return callback([]);
    }
  };

  renderFilterView = () => {
    switch (this.state.toView) {
      case "clusters":
        return this.renderClusters();

      case "areas":
        return this.renderAreas();

      case "branches":
        return this.renderBranches();

      default:
        return "";
    }
  };

  handlebranchCode = (fieldData) => {
    this.setState({ branches: fieldData });
  };

  renderBranches = () => {
    return (
      <FormControl variant="filled" fullWidth>
        <AsyncSelect
          isMulti={true}
          placeholder="Enter Branch Codes"
          cacheOptions
          defaultOptions
          onChange={this.handlebranchCode}
          loadOptions={this.loadOptions}
        />
      </FormControl>
    );
  };

  render() {
    return (
      <Container>
        <Form>
          <Form.Row>
            <FormGroup as={Col}>
              <FormControl className="d-inline">
                <RadioGroup
                  row
                  value={this.state.toView}
                  onChange={this.handleRadioChanged}
                >
                  <FormControlLabel
                    value="overall"
                    control={
                      <Radio
                        size="small"
                        color="primary"
                        value="overall"
                        name="radio-button"
                      />
                    }
                    label="Overall"
                  />
                  <FormControlLabel
                    value="clusters"
                    control={
                      <Radio
                        size="small"
                        color="primary"
                        value="clusters"
                        name="radio-button"
                      />
                    }
                    label="Clusters"
                  />
                  <FormControlLabel
                    value="areas"
                    control={
                      <Radio
                        size="small"
                        color="primary"
                        value="areas"
                        name="radio-button"
                      />
                    }
                    label="Areas"
                  />
                  <FormControlLabel
                    value="branches"
                    control={
                      <Radio
                        size="small"
                        color="primary"
                        value="branches"
                        name="radio-button"
                      />
                    }
                    label="Branches"
                  />
                </RadioGroup>
              </FormControl>
            </FormGroup>
          </Form.Row>
          <Form.Row>
            <FormGroup as={Col}>{this.renderFilterView()}</FormGroup>
          </Form.Row>
          <Form.Row>
            <FormGroup as={Col}>
              <DatePicker
                openTo="year"
                disableToolbar
                fullWidth
                inline
                autoOk
                disableFuture
                label="Covered Date"
                variant="inline"
                inputVariant="outlined"
                format="MMMM YYYY"
                views={["year", "month"]}
                onChange={(e) => {
                  this.handleCurrentDate(e);
                }}
                value={this.state.date}
              />
            </FormGroup>
          </Form.Row>
          <Form.Row>
            <FormGroup as={Col}>
              <Button
                disabled={this.state.isBusy}
                onClick={() => {
                  this.setState({ isBusy: true });
                  let { clusterId, areaId } = this.state;

                  switch (this.state.toView) {
                    case "overall":
                      this.premiseGetOverAll().then((resp) => {
                        if (resp.problem === undefined) {
                          closeModal();
                        } else {
                          this.setState({ isBusy: false });
                        }
                      });
                      break;

                    case "clusters":
                      if (clusterId !== null) {
                        this.premiseGetAverageByCluster(clusterId).then(
                          (resp) => {
                            if (resp.problem === undefined) {
                              closeModal();
                            } else {
                              this.setState({ isBusy: false });
                            }
                          }
                        );
                      } else {
                        toastr.confirm(`Please specify a cluster to proceed.`, {
                          disableCancel: true,
                        });
                        this.setState({ isBusy: false });
                      }
                      break;

                    case "areas":
                      if (areaId !== null) {
                        this.premiseGetAverageByArea(areaId).then((resp) => {
                          if (resp.problem === undefined) {
                            closeModal();
                          } else {
                            this.setState({ isBusy: false });
                          }
                        });
                      } else {
                        toastr.confirm(`Please specify area to proceed.`, {
                          disableCancel: true,
                        });
                        this.setState({ isBusy: false });
                      }

                      break;

                    case "branches":
                      if (this.state.branches.length > 0) {
                        this.premiseGetAverageByBranch(
                          this.state.branches.map((item) => item.value)
                        ).then((resp) => {
                          if (resp.problem === undefined) {
                            closeModal();
                          } else {
                            this.setState({ isBusy: false });
                          }
                        });
                      } else {
                        toastr.confirm(`Please specify a branch to proceed.`, {
                          disableCancel: true,
                        });
                        this.setState({ isBusy: false });
                      }
                      break;

                    default:
                      break;
                  }
                }}
                className="mt-2 float-right"
              >
                {!this.state.isBusy ? (
                  "View"
                ) : (
                  <Spinner size="sm" animation="border" />
                )}
              </Button>
            </FormGroup>
          </Form.Row>
        </Form>
      </Container>
    );
  }

  getLastMonth = (scopeDate) => {
    var currentMonth = new Date(scopeDate);
    var lastMonth = new Date(scopeDate);

    if (leapYear(currentMonth.getFullYear() - 1)) {
      lastMonth.setDate(1);
    }
    lastMonth.setMonth(currentMonth.getMonth() - 1);

    lastMonth.setYear(
      currentMonth.getMonth() === 0
        ? currentMonth.getFullYear() - 1
        : currentMonth.getFullYear()
    );
    return new Date(lastMonth);
  };

  getLastYear = (scopeDate) => {
    var currentYear = new Date(scopeDate);
    var lastYear = new Date(scopeDate);

    if (leapYear(currentYear.getFullYear())) {
      lastYear.setDate(1);
      lastYear.setMonth(currentYear.getMonth());
    }
    lastYear.setMonth(currentYear.getMonth());

    lastYear.setYear(currentYear.getFullYear() - 1);
    return new Date(lastYear);
  };

  getAssignedDates = () => {
    var lastYear = this.getLastYear(this.state.date);
    var lastMonth = this.getLastMonth(this.state.date);
    var current = this.state.date;

    var dates = [
      { current: current, previous: lastYear },
      { current: current, previous: lastMonth },
    ];

    return dates.map((data) => {
      return {
        currentMonth: moment(data.current).format("MM"),
        currentYear: moment(data.current).format("YYYY"),
        previousMonth: moment(data.previous).format("MM"),
        previousYear: moment(data.previous).format("YYYY"),
      };
    });
  };

  premiseGetOverAll = () => {
    var dates = this.getAssignedDates();

    var current = new Date(dates[0].currentYear, dates[0].currentMonth - 1);

    var chartTitle = renderChartTitle(
      moduleNames.salesAverage,
      OperationScope.overall,
      current,
      current
    );
    this.props.SetChartSalesAverageTitle(chartTitle);

    return this.props.GetOverallAverage_v4({
      dates: dates,
    });
  };

  premiseGetAverageByCluster = (clusterId) => {
    var dates = this.getAssignedDates();

    var current = new Date(dates[0].currentYear, dates[0].currentMonth - 1);

    var chartTitle = renderChartTitle(
      moduleNames.salesAverage,
      OperationScope.specifiedCluster,
      current,
      current,
      `${this.state.clusterSelectContext.name} (${this.state.clusterSelectContext.code})`,
      null
    );
    this.props.SetChartSalesAverageTitle(chartTitle);

    return this.props.GetAverageByCluster_v4({
      dates: dates,
      clusterId: clusterId,
    });
  };

  premiseGetAverageByArea = (areaId) => {
    var dates = this.getAssignedDates();

    var current = new Date(dates[0].currentYear, dates[0].currentMonth - 1);

    var chartTitle = renderChartTitle(
      moduleNames.salesAverage,
      OperationScope.specifiedArea,
      current,
      current,
      null,
      `${this.state.areaSelectContext.areaName} (${this.state.areaSelectContext.areaCode})`
    );
    this.props.SetChartSalesAverageTitle(chartTitle);

    return this.props.GetAverageByArea_v4({
      dates: dates,
      areaId: areaId,
    });
  };

  premiseGetAverageByBranch = (branch_codes) => {
    var dates = this.getAssignedDates();

    var current = new Date(dates[0].currentYear, dates[0].currentMonth - 1);

    var chartTitle = renderChartTitle(
      moduleNames.salesAverage,
      OperationScope.specifiedBranch,
      current,
      current,
      null,
      null,
      `Branch (${branch_codes})`
    );
    this.props.SetChartSalesAverageTitle(chartTitle);

    return this.props.GetAverageByBranch_v4({
      dates: dates,
      branch_codes: branch_codes,
    });
  };
}

const mapStateToProps = (state) => {
  return {
    clusters: state.crdm.cluster,
    areas: state.crdm.area,
  };
};

const mapDispatchToProps = {
  GetClusters: GetClusters,
  GetAreas: GetAreas,
  SetChartSalesAverageTitle: SetChartSalesAverageTitle,
  GetAverageByCluster_v4: GetAverageByCluster_v4,
  GetOverallAverage_v4: GetOverallAverage_v4,
  GetAverageByArea_v4: GetAverageByArea_v4,
  GetAverageByBranch_v4: GetAverageByBranch_v4,
  GetBranchByCode: GetBranchByCode,
  // GetAverageByBranch: GetAverageByBranch,
};

export default connect(mapStateToProps, mapDispatchToProps)(AverageViewFilter);
